import dayjs from "dayjs";

import EmissionsTable from "../../modules/tables/EmissionsTable";
import EmissionsDetailsAccordionBlock from "../../layouts/EmissionsDetailsAccordionBlock";
import EmissionsCsvDownload from "../../atoms/buttons/EmissionsCsvDownload";

import { useAccountData } from "../../../helpers/firebase";

const EmissionsDetailsTableAccordion = ({
  type,
  headers = [],
  setSelectedTransaction,
  emissions,
  isExpanded,
  onChange,
  name,
  title = "Table of Emissions",
  subtitle,
  action,
  avatar,
  onSelectRow,
  selectedRows = [],
  noSort,
}) => {
  const [{ name: companyName = "" }] = useAccountData();

  return (
    <EmissionsDetailsAccordionBlock
      avatar={avatar}
      expanded={isExpanded}
      onChange={onChange}
      type={type}
      blockAction={
        action || (
          <EmissionsCsvDownload
            emissions={emissions}
            fileName={`${companyName.split(" ").join("_")}-${dayjs().format(
              "DDMMYYYY"
            )}-${name}-emissions`}
          />
        )
      }
      title={title}
      subtitle={subtitle}
      details={
        <EmissionsTable
          headers={headers}
          setSelectedTransaction={setSelectedTransaction}
          onSelectRow={onSelectRow}
          selectedRows={selectedRows}
          emissions={emissions}
          noSort={noSort}
        />
      }
    />
  );
};
export default EmissionsDetailsTableAccordion;
